import { render, staticRenderFns } from "./after_sales_detail.vue?vue&type=template&id=bff42160&scoped=true"
import script from "./after_sales_detail.vue?vue&type=script&lang=js"
export * from "./after_sales_detail.vue?vue&type=script&lang=js"
import style0 from "./after_sales_detail.vue?vue&type=style&index=0&id=bff42160&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff42160",
  null
  
)

export default component.exports